

import { motion } from 'framer-motion'

// const bars = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
const bars = Array.from({ length: 10 }).map((_, i) => i)

interface VoiceWaveProps {
  isWaveMoving?: boolean
}

const barStyle = 'w-[2px] rounded bg-white/65 h-full'

export function VoiceWave({ isWaveMoving = true }: VoiceWaveProps) {
  if (isWaveMoving) {
    return (
      <div className="flex items-end justify-center gap-1 h-2">
        {
          bars.map((bar, i) => {
            return (
              <motion.div
                key={`${i}-${bar}`}
                animate={{
                  scaleY: [1, 2, 1, 2, 2, 1],
                }}
                transition={{
                  repeat: Infinity,
                  repeatType: 'loop',
                  duration: (bars.length + 1) * 0.1,
                  ease: 'easeInOut',
                  delay: i * 0.1,
                }}
                className={barStyle}
              />
            )
          })
        }
      </div>
    )
  }

  return (
    <div className="flex items-end justify-center gap-1 h-2">
      {
        bars.map((bar, i) => {
          return <div key={`${i}-${bar}`} className={barStyle} />
        })
      }
    </div>
  )
}

// 

